import { createReducer } from 'deox';
import { setMaintainerStatus, setMaintainers } from './actions';
import { IAccessReducer } from '../../types/reducerTypes';

const initialState: IAccessReducer = {
  // isAdmin: false,
  isAdmin: true,
  admins: [],
};

const accessReducer = createReducer(initialState, (handleAction) => [
  handleAction(setMaintainerStatus, (state, { payload }) => ({
    ...state,
    // isAdmin: Boolean(payload),
    isAdmin: true,
  })),
  handleAction(setMaintainers, (state, { payload }) => ({
    ...state,
    admins: payload,
  })),
]);

export default accessReducer;
